
import { setErrorDialog, getheader, serverUrl, getMethodByCallBack, cacheTypes, postMethodByCallBack } from "./CommonFunctions";

export const nationalUrl = serverUrl + "api/CustomersAPI/SearchNationalCode";
export function GetStaffList(Name) {

  return dispatch => {

    dispatch({
      type: 'LOADING',
      data: true,
    })

    fetch(serverUrl + "api/CustomersApi/GetStaff/?name=" + Name, {
      headers: getheader(),
      method: 'GET',
      cache: 'default'
    }).then(res => res.json())
      .then(res => {

        dispatch({
          type: 'LOADING',
          data: false,
        })
        return dispatch({
          type: "GET_STAFF",
          data: res
        })
      }).catch(err => console.error('[err]', err));
  };
}
export function AddNewCustomer(data, fn) {
  let customer = data;
  return dispatch => {
    fetch(serverUrl + "api/CustomersAPI/AddCustomer/", {
      body: JSON.stringify(data),
      headers: getheader(),
      method: "POST"
    })
      .then(res => res.json())
      .then(res => {
        if (res === "ErrorMobile" || res === "ErrorPhone" || res === "ErrorNationalCode") {
          setErrorDialog(dispatch, res, "ثبت مشتری جدید");
          return;
        }
        customer.ID = Number(res);
        if (fn) {
          fn(customer);
        }
      }).catch(err => {
        console.error('[ADD_CUSTOMER]', err);
        alert("اشکال در انجام عملیات");
      });
  }
}
export function getCustomerInfo(fn) {
  const _header = getheader();
  return dispatch => {
    dispatch({
      type: "LOADING",
      data: true
    });
    fetch(serverUrl + "api/CustomersAPI/GetCustomerInfo", {
      headers: _header,
      mode: "cors",
      method: "POST"
    }).then(resp => resp.json())
      .then(resp => {
        dispatch({
          type: "LOADING",
          data: false
        });
        return dispatch({
          type: "FETCH_CURRENT_CUSTOMER",
          data: resp
        })
      }).catch(err => {
        console.log("[FETCH_CURRENT_CUSTOMER]", err);
      })
  }
}
export function searchCustomer(data, onGetData) {
  if ((!data.Name || data.Name === "") &&
    (!data.Code || data.Code === "") &&
    (!data.NationalCode || data.NationalCode === "") &&
    (!data.Mobile || data.Mobile === "")) {
    onGetData({ Error: "هیچکدام از کادرهای جستجو پر نشده است" });
  }
  onGetData("PENDING");
  fetch(serverUrl + "api/CustomersAPI/GetCustomerByFilter", {
    headers: getheader(),
    body: JSON.stringify(data),
    method: "POST"
  }).then(res => res.json())
    .then(res => {
      if (res.Message) {
        onGetData({ Error: res.Message });
        return;
      }
      onGetData(res);
    }).catch(e => console.log("SEARCH_CUSTOMER", e));
}
export function checkNationalCode(NationalCode) {
  if (NationalCode.length === 10) {
    if (NationalCode === '1111111111' ||
      NationalCode === '0000000000' ||
      NationalCode === '2222222222' ||
      NationalCode === '3333333333' ||
      NationalCode === '4444444444' ||
      NationalCode === '5555555555' ||
      NationalCode === '6666666666' ||
      NationalCode === '7777777777' ||
      NationalCode === '8888888888' ||
      NationalCode === '9999999999') {
      return false;
    }
    let c = parseInt(NationalCode.charAt(9));
    let n = parseInt(NationalCode.charAt(0)) * 10 +
      parseInt(NationalCode.charAt(1)) * 9 +
      parseInt(NationalCode.charAt(2)) * 8 +
      parseInt(NationalCode.charAt(3)) * 7 +
      parseInt(NationalCode.charAt(4)) * 6 +
      parseInt(NationalCode.charAt(5)) * 5 +
      parseInt(NationalCode.charAt(6)) * 4 +
      parseInt(NationalCode.charAt(7)) * 3 +
      parseInt(NationalCode.charAt(8)) * 2;
    let r = n - parseInt(n / 11) * 11;
    if (!((r === 0 && r === c) || (r === 1 && c === 1) || (r > 1 && c === 11 - r))) {
      return false;
    }
    else {
      return true;
    }
  }
  else {
    return false;
  }

}
export function getAllCustomerGroups(onGet){
  getMethodByCallBack("api/CustomersAPI/GetAllCustomerGroups",cacheTypes.NoCache, onGet, "GET_CUSTOMER_GROUPS");
}
export function getAllCustomerCampaings(onGetData)
{
  getMethodByCallBack("api/CustomersAPI/GetAllCustomerCampaigns", cacheTypes.NoCache, onGetData,"GET_CUSTOMER_CAMPAIGNS");
}
export function searchPersons(data, onSearch)
{
  postMethodByCallBack(`api/CustomersAPI/SearchPersons`, data, onSearch,"SearchPersons");
}
